import { soundUrl } from "@/lib/slugify";

/**
 * Whether the phone mini player docks for this sound on this route. It stays
 * off the sound's own detail page, which already carries the full player, so
 * a selected sound alone does not mean the strip is showing. The sticky
 * install CTA yields to the strip and must ask the same question, or both
 * bars hide at once on the detail page after a preview.
 */
export function miniPlayerDocks(
  currentSound: { id: string; slug?: string | null } | null | undefined,
  pathname: string | null | undefined,
): boolean {
  return currentSound ? pathname !== soundUrl(currentSound) : false;
}
